// extracted by mini-css-extract-plugin
export var container = "_4q-0";
export var error = "_4q-9";
export var label = "_4q-5";
export var light = "_4q-6";
export var md = "_4q-3";
export var sm = "_4q-2";
export var thin = "_4q-8";
export var thinBold = "_4q-7";
export var vertical = "_4q-4";
export var xs = "_4q-1";